import { AnimatePresence } from 'framer-motion';
import { Box } from '@/ui';
import { printVisibility } from '../../lib/printStyles';
import { getStyleById, type GradientSwatch } from '../../lib/theme';
import type { BackgroundProps } from './Background';
import type { Star as StarType } from './lib';
import { Stars } from './Stars';

type Props = BackgroundProps & {
  stars?: StarType[];
};

export const GradientBackground = ({ themeId, stars }: Props) => {
  const sceneStyle = getStyleById(themeId ?? '');
  const scene = sceneStyle as GradientSwatch | undefined;
  const background = scene?.gradient || 'white';

  return (
    <Box
      inset="0"
      pointerEvents="none"
      pos="fixed"
      sx={printVisibility.hide()}
      zIndex={-1}
      style={{
        background: background,
      }}
    >
      <AnimatePresence>
        <Stars starsOverride={stars} />
      </AnimatePresence>
    </Box>
  );
};
